import posthog from 'posthog-js';

// Check if we're in a browser environment
const isBrowser = typeof window !== 'undefined';

/**
 * Track a custom event with PostHog
 * @param eventName The name of the event to track
 * @param properties Optional properties to include with the event
 */
export const trackEvent = (eventName: string, properties?: Record<string, any>) => {
  if (isBrowser && posthog.isFeatureEnabled?.('analytics')) {
    posthog.capture(eventName, properties);
  }
};

/**
 * Identify a user with PostHog
 * @param userId The unique identifier for the user
 * @param properties Optional user properties to set
 */
export const identifyUser = (userId: string, properties?: Record<string, any>) => {
  if (isBrowser) {
    posthog.identify(userId, properties);
  }
};

/**
 * Reset the current user's identity
 */
export const resetUser = () => {
  if (isBrowser) {
    posthog.reset();
  }
};

/**
 * Track a page view manually
 * @param url The URL to track (defaults to current URL)
 * @param properties Additional properties to include
 */
export const trackPageView = (url?: string, properties?: Record<string, any>) => {
  if (isBrowser) {
    posthog.capture('$pageview', {
      '$current_url': url || window?.location?.href,
      ...properties
    });
  }
};

/**
 * Enable or disable analytics tracking
 * @param enabled Whether analytics should be enabled
 */
export const setAnalyticsEnabled = (enabled: boolean) => {
  if (isBrowser) {
    if (enabled) {
      posthog.opt_in_capturing();
    } else {
      posthog.opt_out_capturing();
    }
  }
};

/**
 * Check if analytics tracking is currently enabled
 * @returns Boolean indicating if tracking is enabled
 */
export const isAnalyticsEnabled = (): boolean => {
  if (isBrowser) {
    return posthog.has_opted_in_capturing();
  }
  return false;
};